// REACT IMPORTS
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// COMPONENTS
import { AppRoutes } from "./routes/router";
import reportWebVitals from "./reportWebVitals";

// CONTEXT 
import { NotificationProvider } from "./context/NotificationContext";

// STYLES
import "./index.css";

// SENTRY
import * as Sentry from "@sentry/react";

// AMPLITUDE 
import * as amplitude from "@amplitude/analytics-browser";

Sentry.init({
  dsn: "https://2b1fc6f0ff96e7116598fc5814fddf56@o4509081000935424.ingest.us.sentry.io/4509081002311680",
});

amplitude.init("69bfc1e45f3d0e5689ac93d93b4d51bd", {
  defaultTracking: {
    attribution: true,
    pageViews: true,
    sessions: true,
    formInteractions: true,
    fileDownloads: true,
  },
});



const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <NotificationProvider>
        <AppRoutes />
      </NotificationProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
